// useTypedRouter.ts
import { type NextRouter, useRouter } from "next/router"

type TypedPush = (
  url: Route | string,
  as?: Route | string,
  options?: Parameters<NextRouter["push"]>[2]
) => ReturnType<NextRouter["push"]>

type TypedReplace = (
  url: Route | string,
  as?: Route | string,
  options?: Parameters<NextRouter["replace"]>[2]
) => ReturnType<NextRouter["replace"]>

export function useTypedRouter() {
  const router = useRouter()

  return {
    ...router,

    // typed push
    push: ((url, as, options) => router.push(url, as, options)) as TypedPush,

    // typed replace
    replace: ((url, as, options) => router.replace(url, as, options)) as TypedReplace,
  }
}

export const Routes = {
  selfCheck: "/selbst-check",
  ratgeber: "/ratgeber",
  datenschutz: "/datenschutz",
  doctors: "/doctors",
  home: "/",
  quickAccess: "/quick-access",
  privacy: "/pdfs/privacy.pdf",
  aboutUs: "/about-us",
  team: "/komm-ins-team",
  partnerInsurances: "/partner-krankenkassen",

} as const

export type Route = (typeof Routes)[keyof typeof Routes]
